import User, {Role} from '../core/auth/user';

export class AlgemeneTip {

  static deserialize(dto: AlgemeneTipDto): AlgemeneTip {
    return new AlgemeneTip(
      dto.id,
      dto.auteurId,
      dto.auteurNummer,
      dto.auteurRol,
      dto.dienstId,
      dto.categorieId,
      dto.taakId,
      dto.content,
      dto.creatieTijdstip,
      dto.laatstGewijzigdeTijdstip,
    );
  }

  constructor(
    private id: string,
    private auteurId: string,
    private auteurNummer: string,
    private auteurRol: Role,
    private dienstId: string,
    private categorieId: string,
    private taakId: string,
    private content: string,
    private creatieTijdstip: string,
    private laatstGewijzigdeTijdstip: string,
  ) {
  }

  getId(): string {
    return this.id;
  }

  getAuteurId(): string {
    return this.auteurId;
  }

  hasAuteurId(authorId: string): boolean {
    return this.auteurId === authorId;
  }

  getAuteurNummer(): string {
    return this.auteurNummer;
  }

  getAuteurRol(): Role {
    return this.auteurRol;
  }

  hasAuteurRole(role: Role): boolean {
    return this.auteurRol === role;
  }

  isFromRegioverantwoordelijke(): boolean {
    return this.hasAuteurRole(Role.REGIOVERANTWOORDELIJKE);
  }

  getDienstId(): string {
    return this.dienstId;
  }

  getCategorieId(): string {
    return this.categorieId;
  }

  getTaakId(): string {
    return this.taakId;
  }

  getContent(): string {
    return this.content;
  }

  getCreatieTijdstip(): string {
    return this.creatieTijdstip;
  }

  getLaatstGewijzigdeTijdstip(): string {
    return this.laatstGewijzigdeTijdstip;
  }

  isEditableBy(user: User): boolean {
    return this.hasAuteurId(user.id)
      || (this.isFromRegioverantwoordelijke() && user.isRegioverantwoordelijke());
  }

  isDeletableBy(user: User): boolean {
    return this.hasAuteurId(user.id) || user.isRegioverantwoordelijke();
  }
}

export interface AlgemeneTipDto {
  id: string;
  auteurId: string;
  auteurNummer: string;
  auteurRol: Role;
  creatieTijdstip: string;
  laatstGewijzigdeTijdstip: string;
  dienstId: string;
  categorieId: string;
  taakId: string;
  content: string;
}
